<template>
  <page-layout :avatar="avatar">
    <!-- 回到顶部 -->
    <div>
      <a-back-top>
        <a-icon type="home" :style="{ fontSize: '30px' }" />
      </a-back-top>
    </div>
    <div slot="headerContent">
      <div class="title" style="width: 600px;">
        <!-- {{ timeFix }},{{ nickname }} -->
        <span class="welcome-text">{{ welcome() }}</span>
      </div>
      <!-- <div>实验中学 | 初中三年级 - 智能英语学习平台</div> -->
      <div data-step="2" v-intro="'升级VIP用户，即可申请加入班级，同步老师作业'">
        <span v-if="classdata.classFlag === '' || classdata.classFlag === null">
          <a-button icon="usergroup-add" type="primary" ghost @click="showApply">
            申请加入班级
          </a-button>
        </span>
        <span v-if="classdata.classFlag === '0'">
          <a-button icon="usergroup-add" type="primary" ghost @click="showApplying" disabled>
            已申请加入班级，等待老师确认
          </a-button>
        </span>
        <span v-if="classdata.classFlag === '1' && classdata.className !== ''">
          <a @click="leave"
            >{{ classdata.schoolName }} | {{ classdata.grade | gradeFolter }} - {{ classdata.className }}</a
          >
        </span>
        <span v-if="classdata.className === '' && classdata.classFlag === '1'">
          <a-button icon="usergroup-add" type="primary" ghost @click="showApply">
            您的班级已解散，点击申请加入班级
          </a-button>
        </span>
        <!-- <span v-if="classdata.classFlag === '1' && userInfo.vipType!=='1'">
          <a-button
            icon="usergroup-add"
            type="primary"
            ghost
            @click="showApply"
          >
            您的云卡已到期，续费即可恢复班级
          </a-button>
        </span> -->
        <span v-if="classdata.classFlag === '2'">
          <a-button icon="usergroup-add" type="primary" ghost @click="showApply">
            上次申请被拒绝，点击申请加入班级
          </a-button>
        </span>
      </div>
    </div>
    <!-- <div
      slot="extra"
      data-step="1"
      v-intro="'升级云卡，解锁所有资源'"
    >
      <a-row class="more-info">
        <a-col :span="24">
          <a @click="cardvip">
            <img
              :style="{width:'350px'}"
              alt="example"
              src="@/assets/vip.jpg"
            />
          </a>
        </a-col>
      </a-row>
    </div> -->
    <div>
      <a-row :gutter="24">
        <a-col :xl="16" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card class="project-list" style="margin-bottom: 24px" :bordered="false">
            <a-row :gutter="48">
              <a-col :span="4">
                <router-link :to="{ name: 'phoneticSymbol' }">
                  <div :style="{ textAlign: 'center', cursor: 'pointer' }">
                    <div class="animationss">
                      <img alt="example" src="@/assets/yinbiao.png" />
                    </div>
                    <p :style="{ fontSize: '10px', margin: '10px', color: 'black' }">音标学习</p>
                  </div>
                </router-link>
              </a-col>
              <a-col :span="4">
                <router-link :to="{ name: 'bookUnit' }">
                  <div :style="{ textAlign: 'center', cursor: 'pointer' }">
                    <div class="animationsss">
                      <img alt="example" src="@/assets/zhuanxiang.png" />
                    </div>
                    <p :style="{ fontSize: '10px', margin: '10px', color: 'black' }">词语速记</p>
                  </div>
                </router-link>
              </a-col>
              <a-col :span="4">
                <router-link :to="{ name: 'AIHearsay' }">
                  <div :style="{ textAlign: 'center', cursor: 'pointer' }">
                    <div class="animations">
                      <img alt="example" src="@/assets/tingshuo.png" />
                    </div>
                    <p :style="{ fontSize: '10px', margin: '10px', color: 'black' }">智能听说</p>
                  </div>
                </router-link>
              </a-col>
              <a-col :span="4">
                <router-link :to="{ name: 'ImproveCourse' }">
                  <div :style="{ textAlign: 'center', cursor: 'pointer' }">
                    <div class="animationss">
                      <img alt="example" src="@/assets/kecheng.png" />
                    </div>

                    <p :style="{ fontSize: '10px', margin: '10px', color: 'black' }">提高课程</p>
                  </div>
                </router-link>
              </a-col>
              <a-col :span="4">
                <router-link :to="{ name: 'read' }">
                  <div :style="{ textAlign: 'center', cursor: 'pointer' }">
                    <div class="animations">
                      <img alt="example" src="@/assets/yuedu.png" />
                    </div>
                    <p :style="{ fontSize: '10px', margin: '10px', color: 'black' }">智能阅读</p>
                  </div>
                </router-link>
              </a-col>
              <a-col :span="4">
                <router-link :to="{ name: 'notebook' }">
                  <div :style="{ textAlign: 'center', cursor: 'pointer' }">
                    <div class="animationsss">
                      <img alt="example" src="@/assets/cuotiben.png" />
                    </div>
                    <p :style="{ fontSize: '10px', margin: '10px', color: 'black' }">错题本</p>
                  </div>
                </router-link>
              </a-col>
            </a-row>
          </a-card>
          <a-card
            class="project-list"
            :loading="loading"
            style="margin-bottom: 24px;"
            :bordered="false"
            title="推荐课程"
            :body-style="{ padding: 0 }"
          >
            <a slot="extra" @click="onMoreCourses">更多课程 <a-icon type="double-right"/></a>
            <recommend-form ref="recommend"></recommend-form>
          </a-card>
          <a-card :loading="loading" title="班级动态" :bordered="false">
            <div v-if="loadData.length > 0">
              <a-carousel autoplay>
                <div v-for="(item, index) in loadData" :key="index">
                  <div v-if="item.dynamicType === '1'">
                    <a-list-item>
                      <a-list-item-meta
                        :title="item.stuName"
                        :description="item.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')"
                      >
                        <a-avatar slot="avatar" :src="item.img" />
                      </a-list-item-meta>
                      <span style="cursor:pointer">
                        <a-icon
                          v-if="item.thumbs === '1'"
                          class="like blue2"
                          type="like"
                          theme="filled"
                          style="color: #2196F3;"
                        />
                        <a-icon v-else class="like blue2" type="like" theme="filled" @click="change(item)" />
                      </span>
                      <span class="classD-icon like classD-w20" id="like1_num">{{ item.count }} </span>
                    </a-list-item>
                    <div>
                      <span>我在</span>
                      <span>【{{ item.dynamicType | dynamicTypeFilter }}】</span>
                      <span>中完成了单词练习哦！练一练才知道自己如此优秀 </span>
                      <span class="like blue2" style="margin-right:8px;color: red;"> <a-icon type="like" /> ! </span>
                    </div>
                    <div
                      :style="{
                        backgroundImage: 'url(' + require('@/assets/bgpic.png') + ')',
                        height: '130px',
                        width: '362px',
                        marginTop: '10px'
                      }"
                    >
                      <span style="font-size:50px;color:white;margin:20px">
                        <a-rate :defaultValue="item.starNum" allowHalf disabled /> </span
                      ><br />
                      <span style="font-size:20px;color:white;margin:20px">
                        恭喜，练习完成
                      </span>
                    </div>
                    <div :style="{ marginTop: '10px' }">
                      <a-icon type="like" />
                      {{ item.personnel }}
                    </div>
                  </div>
                  <div v-if="item.dynamicType === '2'">
                    <a-list-item>
                      <a-list-item-meta
                        :title="item.stuName"
                        :description="item.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')"
                      >
                        <a-avatar slot="avatar" :src="item.img" />
                      </a-list-item-meta>
                      <span style="cursor:pointer">
                        <a-icon
                          v-if="item.thumbs === '1'"
                          class="like blue2"
                          type="like"
                          theme="filled"
                          style="color: #2196F3;"
                        />
                        <a-icon v-else type="like" theme="filled" @click="change(item)" />
                      </span>
                      <span class="classD-icon like classD-w20" id="like1_num">{{ item.count }} </span>
                    </a-list-item>
                    <div>
                      <span>我在</span>
                      <span>【{{ item.dynamicType | dynamicTypeFilter }}】</span>
                      <span>中完成了教材课文朗读练习哦！不练一练怎么知道可以读的这么好？ </span>
                    </div>
                    <div
                      :style="{
                        fontWeight: 'bold',
                        border: '0px solid  #e9e9e9',
                        borderRadius: '10px',
                        backgroundColor: '#bae7ff33',
                        marginTop: '10px',
                        lineHeight: '100px'
                      }"
                    >
                      <a-row :gutter="48">
                        <a-col :span="4">
                          <img :style="{ width: '110px', height: '140px' }" src="@/assets/book.png" />
                        </a-col>
                        <a-col :span="20">
                          <span>
                            <span>获得:</span>
                            <a-rate :defaultValue="item.starNum" allowHalf disabled />
                          </span>
                        </a-col>
                      </a-row>
                    </div>
                    <div :style="{ marginTop: '10px' }">
                      <a-icon type="like" />
                      {{ item.personnel }}
                    </div>
                  </div>
                  <div v-if="item.dynamicType === '3'">
                    <a-list-item>
                      <a-list-item-meta
                        :title="item.stuName"
                        :description="item.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')"
                      >
                        <a-avatar slot="avatar" :src="item.img" />
                      </a-list-item-meta>
                      <span style="cursor:pointer">
                        <a-icon
                          v-if="item.thumbs === '1'"
                          class="like blue2"
                          type="like"
                          theme="filled"
                          style="color: #2196F3;"
                        />
                        <a-icon v-else type="like" theme="filled" @click="change(item)" />
                      </span>
                      <span class="classD-icon like classD-w20" id="like1_num">{{ item.count }} </span>
                    </a-list-item>
                    <div>
                      <span> 一不小心又得好成绩啦！我在</span>
                      <span>【{{ item.dynamicType | dynamicTypeFilter }}】获得</span>
                      <a-rate :defaultValue="item.starNum" allowHalf disabled />
                      <span>，希望每天都能棒棒的！</span>
                    </div>
                    <div
                      :style="{
                        backgroundImage: 'url(' + require('@/assets/bgpic.png') + ')',
                        height: '130px',
                        width: '362px',
                        marginTop: '10px'
                      }"
                    >
                      <span style="font-size:50px;color:white;margin:20px">
                        <a-rate :defaultValue="item.starNum" allowHalf disabled /> </span
                      ><br />
                      <span style="font-size:20px;color:white;margin:20px">
                        恭喜，训练完成
                      </span>
                    </div>
                    <div :style="{ marginTop: '10px' }">
                      <a-icon type="like" />
                      {{ item.personnel }}
                    </div>
                  </div>
                  <div v-if="item.dynamicType === '4' || item.dynamicType === '5'">
                    <a-list-item>
                      <a-list-item-meta
                        :title="item.stuName"
                        :description="item.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')"
                      >
                        <a-avatar slot="avatar" :src="item.img" />
                      </a-list-item-meta>
                      <span style="cursor:pointer">
                        <a-icon
                          v-if="item.thumbs === '1'"
                          class="like blue2"
                          type="like"
                          theme="filled"
                          style="color: #2196F3;"
                        />
                        <a-icon v-else type="like" theme="filled" @click="change(item)" />
                      </span>
                      <span class="classD-icon like classD-w20" id="like1_num">{{ item.count }} </span>
                    </a-list-item>
                    <div>
                      <span v-if="item.dynamicType === '4'"> 考个好成绩就是这么简单！我在</span>
                      <span v-if="item.dynamicType === '5'"> 做出好成绩就是这么简单！我在</span>
                      <span>【{{ item.dynamicType | dynamicTypeFilter }}】获得了</span>
                      <a-rate :defaultValue="item.starNum" allowHalf disabled />
                      <span v-if="item.dynamicType === '4'">，相信自己越考越厉害！</span>
                      <span v-if="item.dynamicType === '5'">，相信自己越做越优秀！</span>
                    </div>
                    <div
                      :style="{
                        backgroundImage: 'url(' + require('@/assets/bgpic.png') + ')',
                        height: '130px',
                        width: '362px',
                        marginTop: '10px'
                      }"
                    >
                      <span style="font-size:50px;color:white;margin:20px">
                        <a-rate :defaultValue="item.starNum" allowHalf disabled /> </span
                      ><br />
                      <span v-if="item.dynamicType === '4'" style="font-size:20px;color:white;margin:20px">
                        恭喜，考试完成
                      </span>
                      <span v-if="item.dynamicType === '5'" style="font-size:20px;color:white;margin:20px">
                        恭喜，作业完成
                      </span>
                    </div>
                    <div :style="{ marginTop: '10px' }">
                      <a-icon type="like" />
                      {{ item.personnel }}
                    </div>
                  </div>
                  <div v-if="item.dynamicType === '6'">
                    <a-list-item>
                      <a-list-item-meta
                        :title="item.stuName"
                        :description="item.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')"
                      >
                        <a-avatar slot="avatar" :src="item.img" />
                      </a-list-item-meta>
                      <span style="cursor:pointer">
                        <a-icon
                          v-if="item.thumbs === '1'"
                          class="like blue2"
                          type="like"
                          theme="filled"
                          style="color: #2196F3;"
                        />
                        <a-icon v-else class="like blue2" type="like" theme="filled" @click="change(item)" />
                      </span>
                      <span class="classD-icon like classD-w20" id="like1_num">{{ item.count }} </span>
                    </a-list-item>
                    <div>
                      <span>我在</span>
                      <span>【{{ item.dynamicType | dynamicTypeFilter }}】</span>
                      <span>中完成了音标挑战哦！练一练才知道自己如此优秀 </span>
                      <span class="like blue2" style="margin-right:8px;color: red;"> <a-icon type="like" /> ! </span>
                    </div>
                    <div
                      :style="{
                        backgroundImage: 'url(' + require('@/assets/bgpic.png') + ')',
                        height: '130px',
                        width: '362px',
                        marginTop: '10px'
                      }"
                    >
                      <span style="font-size:50px;color:white;margin:20px">
                        <a-rate :defaultValue="item.starNum" allowHalf disabled /> </span
                      ><br />
                      <span style="font-size:20px;color:white;margin:20px">
                        恭喜，练习完成
                      </span>
                    </div>
                    <div :style="{ marginTop: '10px' }">
                      <a-icon type="like" />
                      {{ item.personnel }}
                    </div>
                  </div>
                </div>
              </a-carousel>
            </div>
            <div v-else style="text-align: center;">
              暂无数据！
            </div>
            <a slot="extra" @click="onDynamic">全部动态 <a-icon type="double-right"/></a>
          </a-card>
        </a-col>
        <a-col style="padding: 0 12px" :xl="8" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card
            data-step="3"
            v-intro="'完成【同步训练】，获取听、说、读、写、译全能指数'"
            title="单项能力指数"
            style="margin-bottom: 24px"
            :bordered="false"
            :body-style="{ padding: 0 }"
          >
            <!-- 组件引入 -->
            <singleAbility-form ref="singleAbility"></singleAbility-form>
          </a-card>
          <a-card :loading="loading" title="班级排行" :bordered="false">
            <div class="members">
              <span>
                <div style="min-height:150px;width:100%;vertical-align:middle;text-align:center">
                  <img
                    style="width:44%;margin-left:28%;margin-right:28%;margin-bottom:50px"
                    src="@/assets/jiangbei.png"
                  />
                  <span style="font-size:20px;">
                    排行榜暂未开通,敬请期待
                  </span>
                </div>
              </span>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <sync-modal ref="modal"></sync-modal>
    <a-modal title="申请加入班级" v-model="visible" @ok="handleOk">
      <a-spin :spinning="loading">
        <a-form :form="form">
          <a-radio-group @change="onChange" defaultValue="1" buttonStyle="solid" v-model="type">
            <a-radio-button value="1">我有班级码</a-radio-button>
            <a-radio-button value="2">没有班级码</a-radio-button>
          </a-radio-group>

          <div v-if="without">
            <a-form-item label="选择出版社">
              <a-select
                v-decorator="['stuPress', { rules: [{ required: true, message: '请选择出版社' }] }]"
                placeholder="请选择出版社"
                style="width:300px"
              >
                <a-select-option v-for="item in dataPress" :key="item.index" :value="item.value">
                  {{ item.label }}-({{ item.description }})
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="选择年级">
              <a-select
                v-decorator="['grade', { rules: [{ required: true, message: '请选择年级' }] }]"
                placeholder="请选择年级"
                style="width:300px"
              >
                <a-select-option v-for="items in dataGrade" :key="items.id" :value="items.id">
                  {{ items.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <div :style="{ color: 'red' }">
              <p style="height:20px">1.没有班级码时，可以选择加入云学谷学校的班级</p>
              <p style="height:20px">2.请谨慎选择适用自己教材的班级</p>
              <p style="height:20px">3.自己所在学校建立班级后，可以退出云学谷班级然后选择自己学校的班级</p>
            </div>
          </div>

          <div v-else>
            <a-form-item label="班级申请码">
              <a-input
                style="width:300px"
                v-decorator="['classCode', { rules: [{ required: true, message: '请输入班级申请码!' }] }]"
                placeholder="输入班级申请码"
              />
            </a-form-item>
            <div :style="{ color: 'red' }">
              <p style="height:20px">注意事项：</p>
              <p style="height:20px">1.如果学校已开通云学谷,请先向学校老师索取班级码</p>
              <p style="height:20px">2.请输入并仔细核对班级码,确保班级码输入正确</p>
              <p style="height:20px">3.输入班级码后点击【确定】,等待老师审核通过后，即可加入班级</p>
              <p style="height:20px">
                4.学校没有开通云学谷时,可点击上方【没有班级码】选择相应教材后自动加入符合条件的班级
              </p>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </page-layout>
</template>

<script>
import Vue from 'vue'
import { timeFix } from '@/utils/util'
import { mapGetters } from 'vuex'
import PageLayout from '@/components/page/PageLayout'
import HeadInfo from '@/components/tools/HeadInfo'
import Radar from '@/components/chart/Radar'
import SingleAbilityForm from './SingleAbility'
import RecommendForm from './RecommendCourse'
import Flash from '@/components/sub/flash.vue'
import SyncModal from '@/views/learncenter/SyncModal'
import { addObj, getThumbsUpList } from '@/api/datum/thumbs'
// eslint-disable-next-line no-unused-vars
import {
  getDynamicListAll,
  getLearningList,
  getClass,
  putObjClass,
  getClassInfo,
  getAbilityList,
  getRankList,
  removeClass,
  YunxueguClass
} from '@/api/workspace/workspace'
import { getPressList } from '@/api/sys/dict'
import pick from 'lodash.pick'
import 'intro.js/introjs.css'

export default {
  name: 'Workplace',
  components: {
    removeClass,
    PageLayout,
    HeadInfo,
    Radar,
    Flash,
    SyncModal,
    SingleAbilityForm,
    RecommendForm
  },
  data() {
    return {
      type: '1',
      smallOption: [
        { id: '1', title: '一年级' },
        { id: '2', title: '二年级' },
        { id: '3', title: '三年级' },
        { id: '4', title: '四年级' },
        { id: '5', title: '五年级' },
        { id: '6', title: '六年级' }
      ],
      smallOption2: [
        { id: '3', title: '三年级' },
        { id: '4', title: '四年级' },
        { id: '5', title: '五年级' },
        { id: '6', title: '六年级' }
      ],
      smiddleOption: [{ id: '7', title: '七年级' }, { id: '8', title: '八年级' }, { id: '9', title: '九年级' }],
      highOption: [{ id: '10', title: '高一' }, { id: '11', title: '高二' }, { id: '12', title: '高三' }],
      dataGrade: {},
      dataPress: {},
      without: false,
      classCode: '',
      form: this.$form.createForm(this),
      classdata: {},
      queryParam: {},
      studentId: '',
      loadData: [],
      height2: 400,
      timeFix: timeFix(),
      user: {},
      visible: false,
      loading: true,
      teams: [],
      thumbsUpList: []
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar', 'userInfo'])
  },
  filters: {
    gradeFolter(grade) {
      const gradeMap = {
        1: '一年级',
        2: '二年级',
        3: '三年级',
        4: '四年级',
        5: '五年级',
        6: '六年级',
        7: '七年级',
        8: '八年级',
        9: '九年级',
        10: '高一',
        11: '高二',
        12: '高三'
      }
      return gradeMap[grade]
    },
    dynamicTypeFilter(value) {
      const valueMap = {
        1: '词语速记',
        2: '智能听说',
        3: '同步训练',
        4: '考试',
        5: '作业',
        6: '音标学习'
      }
      return valueMap[value]
    }
  },
  created() {
    this.MessageDetail()
    this.user = this.userInfo
    this.handelThumbsUpList()
    this.handelDynamicList()
    // console.log('userInfo:' + JSON.stringify(this.userInfo))
  },
  mounted() {
    this.getProjects()
    if (Vue.ls.get('guide') === null) {
      Vue.ls.set('guide', true)
      this.$nextTick(() => {
        this.$intro()
          .setOptions({
            prevLabel: '&larr; 上一步',
            nextLabel: '下一步 &rarr;',
            skipLabel: '跳过指引',
            Done: '结束 &rarr;'
          })
          .start()
      })
    }
  },
  methods: {
    onChange(e) {
      if (e.target.value === '2') {
        this.without = true
        this.getDictList()
      } else {
        this.without = false
      }
    },
    // 获取出版社
    getDictList() {
      const mdl = {}
      mdl.type = 'press_type'
      mdl.period = this.userInfo.stuSection
      getPressList(Object.assign(mdl)).then(res => {
        this.dataPress = res.result
      })
      if (mdl.period === '1') {
        if (this.userInfo.originType === '1') {
          this.dataGrade = this.smallOption
        } else if (this.userInfo.originType === '2') {
          this.dataGrade = this.smallOption2
        }
      } else if (mdl.period === '2') {
        this.dataGrade = this.smiddleOption
      } else if (mdl.period === '3') {
        this.dataGrade = this.highOption
      }
    },
    // 退出班级
    leave() {
      this.$confirm({
        title: '是否需要退出班级?',
        content: '点击【确定】退出班级, 点击【取消】关闭此消息.',
        okText: '确定',
        cancelText: '取消',
        okButtonProps: {
          on: {
            click: this.onYes
          }
        },
        onCancel() {}
      })
    },
    onYes() {
      console.log('this.userInfo' + JSON.stringify(this.userInfo))
      this.studentId = this.userInfo.id
      console.log('this.studentId' + this.studentId)
      removeClass(this.studentId)
        .then(res => {
          this.$message.success('退出成功')
          this.classdata.classFlag = ''
          this.MessageDetail()
          this.user = this.userInfo
          this.handelThumbsUpList()
          this.handelDynamicList()
        })
        .catch(() => {
          this.$message.error('退出失败')
        })
        .finally(() => {
          this.$refs.singleAbility.handlePersonal()
        })
    },
    // 是否需要撤回加入班级
    showApplying() {
      // getClass().then(res => {
      //   this.classCode = res.result.classCode
      // })
      this.$confirm({
        title: '是否需要撤回班级码?',
        content: '点击【确定】撤回 , 点击【取消】关闭此消息.',
        okText: '确定',
        cancelText: '取消',
        okButtonProps: {
          on: {
            click: this.onOk
          }
        },
        onCancel() {}
      })
    },
    onOk() {
      console.log('this.userInfo' + JSON.stringify(this.userInfo))
      this.studentId = this.userInfo.id
      console.log('this.studentId' + this.studentId)
      removeClass(this.studentId)
        .then(res => {
          this.$message.success('撤回成功')
          this.classdata.classFlag = ''
        })
        .catch(() => {
          this.$message.error('撤回失败')
        })
        .finally(() => {})
    },
    // 申请加入班级，提交按钮逻辑处理
    handleOk(e) {
      e.preventDefault()
      const _this = this
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('values.stuPress:' + values.stuPress)
          console.log('values.grade:' + values.grade)
          console.log('_this.type' + _this.type)
          if (_this.type === '1') {
            this.queryParam = {}
            this.queryParam.classCode = values.classCode
            getClassInfo(Object.assign(this.queryParam)).then(res => {
              const data = res.result
              if (data !== null && data !== '') {
                _this.loading = true
                this.queryParam.schoolId = res.result.schoolId
                // this.queryParam.classYear = res.result.gradeId
                this.queryParam.stuTeam = res.result.id
                this.queryParam.permitsFlag = res.result.permitsFlag
                if (this.queryParam.permitsFlag === '1') {
                  this.queryParam.classFlag = '0'
                  putObjClass(Object.assign(this.queryParam))
                    .then(() => {
                      _this.$message.success('申请成功')
                      this.classdata.classFlag = '0'
                      this.queryParam = {}
                    })
                    .catch(() => {
                      _this.$message.error('申请失败')
                    })
                    .finally(() => {
                      _this.loading = false
                      _this.visible = false
                    })
                } else {
                  this.$message.error('该班级暂时不允许加入！')
                  _this.loading = false
                }
              } else {
                this.$message.error('不存在该班级，请确认班级码是否有误！')
              }
            })
          } else if (_this.type === '2') {
            this.queryParam = {}
            this.queryParam.stuPress = values.stuPress
            this.queryParam.grade = values.grade
            console.log('data:' + this.queryParam.grade + this.queryParam.stuPress)
            YunxueguClass(this.queryParam)
              .then(res => {
                _this.loading = true
                _this.$message.success('加入成功')
              })
              .catch(() => {
                _this.$message.error('此教材下暂时没有班级')
              })
              .finally(() => {
                _this.loading = false
                _this.visible = false
                this.MessageDetail()
                this.user = this.userInfo
                this.handelThumbsUpList()
                this.handelDynamicList()
                this.$refs.singleAbility.handlePersonal()
              })
          }
        }
      })
    },
    handelDynamicList() {
      this.queryParam = {}
      this.spinning = true
      getDynamicListAll(Object.assign(this.queryParam))
        .then(res => {
          // console.log('data:' + JSON.stringify(res.result))
          this.handelData(res.result)
        })
        .catch(() => {
          this.$message.error('网络异常')
        })
        .finally(() => {
          this.spinning = false
        })
    },
    handelThumbsUpList() {
      getThumbsUpList(Object.assign(this.queryParam))
        .then(res => {
          this.thumbsUpList = res.result
        })
        .catch(() => {
          this.$message.error('网络异常')
        })
    },
    handelData(data) {
      data.forEach((item, i) => {
        let personnel = ''
        this.thumbsUpList.forEach((items, i) => {
          if (items.dynamicId === item.id) {
            personnel = personnel + items.stuName + ' , '
          }
        })
        item.personnel = personnel
      })
      this.loadData = data
      // console.log('data:' + JSON.stringify(this.loadData))
    },
    // 点赞
    change(value) {
      this.queryParam = {}
      this.queryParam.dynamicId = value.id
      addObj(Object.assign(this.queryParam))
        .then(() => {
          const data = this.loadData.filter(item => item.id === value.id)[0]
          data.count += 1
          data.thumbs = '1'
          data.personnel = data.personnel + this.userInfo.stuName + ' , '
        })
        .catch(() => {
          this.$message.error('网络异常')
        })
    },

    // 页面初始化查询所在班级
    MessageDetail() {
      getClass().then(res => {
        this.classdata = res.result
        // console.log('查询所在班级' + JSON.stringify(this.classdata))
      })
    },
    // 申请加入班级模态框
    showApply() {
      // if (this.userInfo.vipType === '1') {
      this.visible = true
      getClass().then(res => {
        this.classdata = res.result
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(res.result, 'classCode'))
        })
        this.classCode = res.result.classCode
      })
      // } else {
      //   this.$confirm({
      //     title: '购买云卡，升级解锁全部资源？',
      //     // content: '退出后将保存做题进度',
      //     okText: '升级',
      //     cancelText: '取消',
      //     okButtonProps: {
      //       on: {
      //         click: this.clickHandler
      //       }
      //     }
      //   })
      // }
    },
    clickHandler() {
      this.$router.push({ path: '/cloudCard' })
    },
    // 更多课程
    onMoreCourses() {
      this.$router.push({ name: 'ImproveCourse' })
    },
    onDynamic() {
      this.$router.push({ name: 'classDynamics' })
    },
    cardvip() {
      this.$router.push({ path: '/cloudCard', params: {} })
    },
    onRankChange() {
      // this.$router.push({ name: 'ranking' })
    },
    handleToHome() {
      this.$router.push({ name: 'BaseForm' })
    },
    ...mapGetters(['welcome']),
    getProjects() {
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.animation {
  -webkit-transition: width 0.5s, height 0.5s, -webkit-transform 1s;
  transition: width 0.5s, height 0.5s, transform 0.5s;
  margin: 0;
}
.animation:hover {
  // -webkit-transform: rotate(360deg);
  //     transform: rotate(360deg);
  margin-left: -12px;
}
.animations {
  -webkit-transition: width 1s, height 1s, -webkit-transform 1s;
  transition: width 1s, height 1s, transform 1s;
}
.animations:hover {
  -webkit-transform: rotate(360deg) scale(1.2);
  transform: rotate(360deg) scale(1.2);
}
.animationss {
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transition: 1s;
  -webkit-transition: 1s;
  -ms-transition: 1s;
  -moz-transition: 1s;
}
.animationss:hover {
  transform: translateZ(30px) rotateY(360deg) scale(1.2);
  -webkit-transform: translateZ(30px) rotateY(360deg) scale(1.2);
  -ms-transform: translateZ(30px) rotateY(360deg) scale(1.2);
  -moz-transform: translateZ(30px) rotateY(360deg) scale(1.2);
}
.animationsss {
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transition: 1s;
  -webkit-transition: 1s;
  -ms-transition: 1s;
  -moz-transition: 1s;
}
.animationsss:hover {
  transform: translateZ(30px) rotateX(360deg) scale(1.2);
  -webkit-transform: translateZ(30px) rotateX(360deg) scale(1.2);
  -ms-transform: translateZ(30px) rotateX(360deg) scale(1.2);
  -moz-transform: translateZ(30px) rotateX(360deg) scale(1.2);
}
.project-list {
  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }
  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }
    .datetime {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }
  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;
  a {
    // color: rgba(0, 0, 0, 0.65);
    color: #40a9ff;
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.members {
  a {
    display: block;
    margin: 12px 0;
    line-height: 24px;
    height: 24px;
    span {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      line-height: 22px;

      &:first-child {
        background-color: #f5f5f5;
        border-radius: 20px;
        display: inline-block;
        font-size: 12px;
        font-weight: 600;
        margin-right: 24px;
        height: 20px;
        line-height: 20px;
        width: 20px;
        text-align: center;
      }
      &.active {
        background-color: #314659;
        color: #fff;
      }
      &:last-child {
        float: right;
      }
    }
    .member {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.65);
      //行间距
      line-height: 24px;
      height: 24px;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      // 段落文本不换行
      white-space: nowrap;
      // 元素的垂直对齐方式
      vertical-align: middle;
      margin-left: 20px;
      transition: all 0.3s;
      display: inline-block;
    }
    .member2 {
      margin-left: 12px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      //行间距
      line-height: 24px;
      height: 24px;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      // 段落文本不换行
      white-space: nowrap;
      // 元素的垂直对齐方式
      vertical-align: middle;
      margin-left: 20px;
      transition: all 0.3s;
      display: inline-block;
    }
    &:hover {
      span {
        color: #1890ff;
      }
    }
  }
}

.mobile {
  .project-list {
    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }

  .img-hover {
    -webkit-transition: width 0.5s, height 0.5s, -webkit-transform 1s; /* For Safari 3.1 to 6.0 */
    transition: width 0.5s, height 0.5s, transform 0.5s;
  }
  .img-hover:hover {
    -webkit-transform: rotate(360deg); /* Chrome, Safari, Opera */
    transform: rotate(360deg);
  }
  .classDynamics {
    font-size: 16px;
  }
  .middle {
    margin: 20px;
    height: 140px;
    width: 400px;
    background: no-repeat center top;
    background-size: contain;
  }
  // .classD-icon {
  //   font-size: 18px;
  // }
  // .classD-w20 {
  //   width: 20px;
  // }
}
</style>
